import api from '../config/api';

export const wishlistService = {
  getWishlist: async (params = {}) => {
    const response = await api.get('/wishlist', { params });
    return response.data;
  },

  addToWishlist: async (productId) => {
    const response = await api.post('/wishlist', { product_id: productId });
    return response.data;
  },

  removeFromWishlist: async (productId) => {
    const response = await api.delete(`/wishlist/${productId}`);
    return response.data;
  },

  checkInWishlist: async (productId) => {
    const response = await api.get(`/wishlist/check/${productId}`);
    return response.data;
  },

  clearWishlist: async () => {
    const response = await api.delete('/wishlist');
    return response.data;
  },

  getWishlistCount: async () => {
    const response = await api.get('/wishlist/count');
    return response.data;
  },
};

export default wishlistService;